module.exports = __webpack_public_path__ + "img/plan-a-info-title-01-mobile.a23ac660.png";